import * as Yup from 'yup';

import { VALIDATOR } from '../validator';

export const tenantScheme = Yup.object({
  title: VALIDATOR.title,
  address1_country: VALIDATOR.requiredString,
  address1_city: VALIDATOR.requiredString,
  address1_street: VALIDATOR.requiredString,
  address1_state: VALIDATOR.requiredString,
  address1_zip: VALIDATOR.zipcode,
  phone: VALIDATOR.phone,
  website: VALIDATOR.website.notRequired(),
  contact_phone: VALIDATOR.phone.notRequired(),

  // ERMA-3239: this functionality is not needed for now
  // slug: Yup.string()
  //   .matches(validation.subdomain, i18next.t('validations.subdomainFormat'))
  //   .max(64, i18next.t('validations.subdomainLength', { size: 64 }))
  //   .required(i18next.t('validations.required')),
});
